import React from 'react';

const Product = ({ headline, info, image }) => {
    const whatsappNumber = '+972544423984'; // WhatsApp number
    const message = `היי, אשמח לקבל פרטים בנוגע למוצר ${headline}`;

    const handleWhatsAppClick = () => {
        const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(message)}`;
        window.open(whatsappLink, '_blank');
    };

    return (
        <div className="max-w-[20rem]  mx-auto my-4 px-2 shadow-2xl bg-white text-black rounded-3xl z-10">

            <div className="flex flex-col justify-between p-6 space-y-8">
                <div className="space-y-2">
                    <h2 className="text-xl font-bold">{headline}</h2>
                    <p dir='rtl' className='text-xs'>{info}</p>
                </div>
                <img className='rounded-3xl border-2 border-white' src={image} alt="" style={{ width: '300px', height: '200px' }} />

                <button
                    onClick={handleWhatsAppClick}
                    className="mt-4 mx-auto rounded-full flex items-center border-4 py-2 bg-gradient-to-l from-mainSave to-secondarySave text-textSave px-7 border-borderSave hover:opacity-95 hover:scale-[108%] duration-300 shadow-lg"
                >
                    <span className='pr-1.5 gold-text text-lg mb-1 font-black'> לייעוץ ורכישה לחצו כאן</span>
                </button>

            </div>
        </div>
    );
};

export default Product;
